import { useState } from 'react'
import Container from 'components/common/Container'
import Heading from 'components/common/Heading'
import Button from 'components/common/Button'

import { GiCheckMark } from 'react-icons/gi';

const generateFizzBuzzString = () => {
    const final = [];

    for (let i=1; i < 101; i++){
        if (i % 15 === 0) final.push('FizzBuzz');
        else if (i % 3 === 0) final.push('Fizz');
        else if (i % 5 === 0) final.push('Buzz');
        else final.push(i);
    }

    return final;
}

const Warmup = () => {
    const [solution, setSolution] = useState([]);

    return (
        <Container className="py-4">
            <Heading className="mb-4">
                1. Warmup
            </Heading>

            <div className="mb-4">
                <p className="mb-2">
                    Feel free to just create a JavaScript file to solve this task, no need to implement it with React
                </p>
                <ul>
                    <li>
                        <span className="flex items-center">
                            Add a button to a HTML5 page <GiCheckMark className="text-green-500 ml-1" />
                        </span>
                    </li>
                    <li>
                        <span className="flex">
                            When the button is pressed print numbers from 1 to 100. But for multiples of three print "Fizz" instead of the number and for the multiples of five print "Buzz". For numbers which are multiples of both three and five print "FizzBuzz". <GiCheckMark className="text-green-500 ml-1" />
                        </span>
                    </li>
                    <li>
                        <span className="flex items-center">
                            Each number/fizz should be in a new line <GiCheckMark className="text-green-500 ml-1" />
                        </span>
                    </li>
                </ul>
            </div>

            <Heading as="h3" className="mb-2">
                Solution
            </Heading>

            <div>
                <ul>
                    {
                        solution.map((item, idx) => <li key={idx}>{item}</li>)
                    }
                </ul>
                {
                    !solution.length > 0 && (
                        <Button onClick={() => setSolution(generateFizzBuzzString())}>
                            FizzBuzz me
                        </Button>
                    )
                }
            </div>
        </Container>
    )
}

export default Warmup